import * as Vue from "vue";
import {Component} from "vue-property-decorator";
import "./automationsView.styl";
const template = require("./automationsView.vue");

@Component({
  template: template
})
export class AutomationsViewComponent extends Vue {

}

Vue.component("cmAutomationsView", AutomationsViewComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/views/automationsView/automationsView.ts